import React from 'react';
import {GlobalContext} from "../../GlobalContext";
import {Card, Table} from "react-bootstrap";
import {Link} from 'react-router-dom';

export class SchedulingToDoList extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            toDoListTitle: "Loading To-Do List...",
            todos: []
        };
    }

    timer = null;
    _mounted = false;

    componentDidMount() {
        this._mounted = true;
        this.loadTaskList();
    }

    componentWillUnmount() {
        this._mounted = false;
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    scheduleNextPoll = () => {
        if (!this._mounted || !this.context.authenticated) return;
        this.timer = setTimeout(this.loadTaskList, 15000);
    }

    loadTaskList = () => {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        if (!this._mounted || !this.context.authenticated) return;
        this.context.apiRequest("GET", '/scheduling/to-do-list', null, true)
            .then(d => {
                if (!this._mounted) return;
                if (d) {
                    this.setState({todos: d.data, toDoListTitle: "Scheduling To-Do List"}, () => {
                        if (this._mounted && this.context.authenticated) {
                            this.scheduleNextPoll();
                        }
                    })
                }
            });
    }

    render() {
        let rows = [];
        let compareDt = '';
        this.state.todos.forEach(todo => {
            if(compareDt !== todo.dueDate) {
                rows.push(<tr key={todo.dueDate}><td colSpan={3} className={"small"}><strong>{todo.dueDate}</strong></td></tr>);
                compareDt = todo.dueDate;
            }
            rows.push(
                <tr key={todo.referralId}>
                    <td className={"pl-3 small"}>
                        <Link className="text-dark" replace={true} to={`/patients/${todo.patientId}`}>{todo.lastName}, {todo.firstName}</Link>
                    </td>
                    <td className={"small"}>{todo.owner || ''}</td>
                    <td className={"small"}>{todo.activityContactTypeCode}</td>
                </tr>);
        })

        return (
            <Card className={this.props.className || "dashboardSideBox"}>
                <Card.Header>{this.state.toDoListTitle}</Card.Header>
                <Card.Body>
                    <Table size={"sm"}>
                        <thead>
                        <tr>
                            <th className={"small"}><strong>Due Date/Patient</strong></th>
                            <th className={"small"}><strong>Owner</strong></th>
                            <th className={"small"}><strong>Last</strong></th>
                        </tr>
                        </thead>
                        <tbody>
                        {rows}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        );
    }
}
